<div class="ratingContainer">
  <p class="instruction">這個情緒有多強烈？</p>

  <div class="sliderContainer">
    <div class="legend left">非常輕微</div>
    <div class="slider" [class.slider-clicked]="firstClicked">
      <ngx-slider
        [(value)]="value"
        [options]="options"
        (userChangeStart)="onRatingClicked()"
      ></ngx-slider>
    </div>
    <div class="legend right">非常強烈</div>
  </div>

  <div class="confirmButtonContainer">
    <div
      *ngIf="firstClicked"
      class="confirmButton"
      (click)="onConfirmButtonClicked()"
    >
      確定
    </div>
  </div>
</div>
